import { UserGroupIcon, UsersIcon } from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "All Groups",
    href: "/hub/community",
    icon: UserGroupIcon,
    current: false,
    internalName: "community_all_groups",
  },
  {
    name: "My Groups",
    href: "/hub/community?filter=my-groups",
    icon: UsersIcon,
    current: false,
    internalName: "community_my_groups",
  },
];

const communityConfig = {
  sectionName: "community",
  defaultRoute: "/hub/community",
  navigation,
};

export default communityConfig;
